// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/experiment.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3, Timestamp } from "@bufbuild/protobuf";
import { Metadata } from "./entity_pb.js";
import { Tag } from "./tag_pb.js";

/**
 * Represents a single ML experiment, its metadata, and any artifacts.
 *
 * @generated from message ai.h2o.storage.Experiment
 */
export const Experiment = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.Experiment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "last_modified_time", kind: "message", T: Timestamp },
    { no: 7, name: "metadata", kind: "message", T: Metadata },
    { no: 8, name: "parameters", kind: "message", T: ExperimentParameters },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(Experiment_ExperimentStatus) },
    { no: 10, name: "statistics", kind: "message", T: ExperimentStatistics },
    { no: 11, name: "tag", kind: "message", T: Tag, repeated: true },
    { no: 12, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum ai.h2o.storage.Experiment.ExperimentStatus
 */
export const Experiment_ExperimentStatus = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.storage.Experiment.ExperimentStatus",
  [
    {no: 0, name: "EXPERIMENT_STATUS_UNSPECIFIED"},
    {no: 1, name: "TRAINING"},
    {no: 2, name: "FINISHED"},
    {no: 3, name: "STOPPING"},
    {no: 4, name: "FAILED"},
    {no: 5, name: "ABORTED"},
  ],
);

/**
 * Original configuration parameters of the experiment.
 *
 * @generated from message ai.h2o.storage.ExperimentParameters
 */
export const ExperimentParameters = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ExperimentParameters",
  () => [
    { no: 7, name: "training_dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "validation_dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "test_dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target_column", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "weight_column", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "fold_column", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Statistics about the experiment progress & result.
 *
 * @generated from message ai.h2o.storage.ExperimentStatistics
 */
export const ExperimentStatistics = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.ExperimentStatistics",
  () => [
    { no: 1, name: "training_duration", kind: "message", T: Duration },
  ],
);

